import { gql } from '@apollo/client';

const GET_TIME_ZONE = gql`
  query timeZones {
    timeZones {
      id
      code
      name
      gmtOffset
      enabled
      sortOrder
    }
  }
`;

export default GET_TIME_ZONE;
